var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-modal",
    {
      key: _vm.renderKey,
      staticClass: "scheduler-modal",
      attrs: {
        "action-required": "",
        fullscreen: _vm.fullScreen,
        visible: _vm.showSchedulerModal,
        width: "600px",
      },
    },
    [
      !_vm.scheduleFeed
        ? _c("scheduler-modal-wrapper", {
            attrs: {
              "show-scheduler-modal": _vm.showSchedulerModal,
              "modal-loading": _vm.modalLoading,
              "performance-report-parameters": _vm.performanceReportParameters,
              "grid-view-parameters": _vm.gridViewParameters,
              "save-feed-response": _vm.saveFeedResponse,
              "save-feed-status": _vm.saveFeedStatus,
              "has-duplicate-name": _vm.hasDuplicateName,
              "error-loading-parameters": _vm.errorLoadingParameters,
            },
            on: {
              "get-parameters": _vm.getParameters,
              save: _vm.createFeed,
              close: function ($event) {
                return _vm.$emit("close", $event)
              },
              "hide-feedback-message": _vm.hideFeedbackMessage,
            },
          })
        : _c("frequency-modal-wrapper", {
            attrs: {
              "modal-loading": _vm.modalLoading,
              "save-schedule-response": _vm.saveScheduleResponse,
              "save-schedule-status": _vm.saveScheduleStatus,
              "feed-id": _vm.feedId,
              "has-duplicate-name": _vm.hasDuplicateName,
            },
            on: {
              createSchedule: _vm.createSchedule,
              close: function ($event) {
                return _vm.$emit("close", $event)
              },
              "hide-feedback-message": _vm.hideFeedbackMessage,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }